// Copyright ©️ 2026 eVolve MEP, LLC

import React, { useEffect, useMemo } from 'react';

import { type WorkOrder, useEvolvePaginatedGet } from '@evolvemep/api-ts';

import type { GlobalFilterProps } from 'components/Mantine/GlobalFilters/types';
import { SearchableMultiSelect } from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableMultiSelect';
import { getDisplayNameWO } from 'modules/Shop/WorkOrders/WorkOrderDetail/common';

export const WorkOrdersFilter = ({ filter, value, onChange, defaultParams }: GlobalFilterProps<'workOrders'>) => {
  const params = useMemo(
    () => ({
      ...defaultParams,
      ...(typeof filter === 'boolean' ? undefined : filter),
    }),
    [defaultParams, filter],
  );
  const { setDefaultOpts, ...getWorkOrders } = useEvolvePaginatedGet('shop/workOrder', {
    defaultConfig: {
      params,
    },
  });
  useEffect(() => {
    setDefaultOpts({
      defaultConfig: {
        params,
      },
    });
  }, [params, setDefaultOpts]);

  if (!filter) return null;
  // TODO: Factor out a common work orders searchable select component with FWP-850
  return (
    <SearchableMultiSelect<'shop/workOrder', WorkOrder, 'workOrderId'>
      label="Work Orders"
      placeholder="All Work Orders"
      paginatedGet={getWorkOrders}
      autoDropdownWidth
      getItemLabel={getDisplayNameWO}
      idKey="workOrderId"
      searchKey="searchPhrase"
      value={value}
      onChange={onChange}
      comboboxProps={{ withinPortal: false }}
      clearable
      preloadData
    />
  );
};
